import Button, { ButtonProps } from '@mui/material/Button';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#ff7a3d',
            contrastText: '#120703'
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '999px',
                    padding: '.75rem 1.35rem',
                    fontWeight: 800,
                    letterSpacing: '.04em',
                    textTransform: 'uppercase',
                    boxShadow: 'none'
                },
                contained: {
                    background: 'linear-gradient(135deg, #ff6b2b, #ffb088)',
                    color: '#160600',
                    boxShadow: '0 18px 45px rgba(255, 91, 39, .28)',
                    '&:hover': {
                        boxShadow: '0 22px 60px rgba(255, 91, 39, .38)'
                    }
                },
                outlined: {
                    color: '#fff',
                    borderColor: 'rgba(255,255,255,.4)',
                    background: 'rgba(255,255,255,.04)',
                    backdropFilter: 'blur(10px)',
                    '&:hover': {
                        borderColor: '#ff9b66',
                        background: 'rgba(255, 107, 43, .12)'
                    }
                }
            }
        }
    }
})

const ThemedButton = (props: ButtonProps) => (
    <ThemeProvider theme={theme}>
        <Button {...props} />
    </ThemeProvider>
)

export default ThemedButton
